/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_appsync_graphqlEndpoint": "https://3i3rcpnserautmzaugdytnfy7y.appsync-api.us-east-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-2",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-pggh5x7uczbkdfswv2vhkdyunm",
    "aws_cognito_identity_pool_id": "us-east-2:f414ee01-94bf-402c-88ad-b9639533d3f7",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_WvYIfpN98",
    "aws_user_pools_web_client_id": "37l26bvif5fl3p0nercv9m88qr",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "wilmingtonsantaphotos134626-prod",
    "aws_user_files_s3_bucket_region": "us-east-2"
};


export default awsmobile;
